const roleMapping = {
  data_entry_operator: "Data Entry Operator",
  chief_of_staff: "Chief of Staff",
  constituency_manager: "Constituency Manager",
  office_manager: "Office Manager",
  client: "Client",
  cadre: "Cadre"
};
export { roleMapping };